import { Link } from "react-router-dom";
import { Reveal, ChapterLabel } from "@/components/site/Reveal";
import { IMAGES } from "@/lib/content";
import { LifeBuoy, Sprout, ArrowRight } from "lucide-react";

const CARDS = [
  {
    to: "/hilfe",
    testId: "teaser-hilfe",
    icon: LifeBuoy,
    tag: "Notfall & Erste Hilfe",
    title: "Braucht dieser Igel Hilfe?",
    text: "Woran du erkennst, ob ein Igel in Not ist – und die fünf wichtigsten Schritte, wenn du einen gefunden hast.",
    img: IMAGES.hero,
    color: "bg-brand-pink",
  },
  {
    to: "/tipps",
    testId: "teaser-tipps",
    icon: Sprout,
    tag: "Garten, Futter & Auswilderung",
    title: "Gutes tun für Igel",
    text: "So machst du deinen Garten igelfreundlich, fütterst richtig und begleitest kleine Wildlinge zurück in die Freiheit.",
    img: IMAGES.garden,
    color: "bg-brand-green",
  },
];

export default function Teaser() {
  return (
    <section data-testid="section-teaser" id="wobei" className="relative py-20 md:py-32">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <ChapterLabel index={1} label="Wobei kann ich dir helfen?" color="text-brand-orange" />
        <Reveal className="mt-6 max-w-2xl">
          <h2 className="font-heading font-bold text-ink text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Alles Wichtige an einem Ort
          </h2>
          <p className="mt-4 text-lg md:text-xl leading-relaxed text-ink-muted">
            Damit du nicht lange suchen musst – wähle einfach, worum es gerade geht.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
          {CARDS.map((c, i) => (
            <Reveal key={c.to} delay={i * 0.1}>
              <Link
                to={c.to}
                data-testid={c.testId}
                className="group relative block overflow-hidden rounded-[2.5rem] shadow-card h-full"
              >
                <div className="relative aspect-[3/4] sm:aspect-[16/11] overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/25 to-transparent" />
                </div>
                <div className="absolute inset-0 p-6 sm:p-8 md:p-10 flex flex-col justify-end text-white">
                  <span className={`${c.color} w-12 h-12 rounded-full flex items-center justify-center shadow-soft`}>
                    <c.icon className="w-6 h-6" />
                  </span>
                  <span className="mt-4 text-xs sm:text-sm font-semibold uppercase tracking-wider text-white/80">
                    {c.tag}
                  </span>
                  <h3 className="mt-1 font-heading font-extrabold text-2xl md:text-3xl">
                    {c.title}
                  </h3>
                  <p className="mt-2 text-white/85 text-sm sm:text-base md:text-lg leading-relaxed max-w-md">
                    {c.text}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-2 font-semibold">
                    Mehr erfahren
                    <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
